<!-- O vivest-button não submete o form; o Enter nos campos dispara a busca por aqui. -->
<form
  class="filter-bar"
  [formGroup]="form"
  aria-label="Filtros"
  (keydown.enter)="$event.preventDefault(); buscar()"
>
  @for (field of fields(); track field.key) {
    @if (field.type === 'text') {
      <div class="filter-bar__field">
        <label class="filter-bar__label" [for]="'filter-' + field.key">
          {{ field.label }}
        </label>
        <input
          [id]="'filter-' + field.key"
          type="search"
          class="filter-bar__control"
          [formControlName]="field.key"
          [placeholder]="field.placeholder ?? ''"
          autocomplete="off"
          [attr.data-testid]="'filter-' + field.key"
        />
      </div>
    }

    @if (field.type === 'select') {
      <div class="filter-bar__field">
        <label class="filter-bar__label" [for]="'filter-' + field.key">
          {{ field.label }}
        </label>
        <select
          [id]="'filter-' + field.key"
          class="filter-bar__control"
          [formControlName]="field.key"
          [attr.data-testid]="'filter-' + field.key"
        >
          @for (option of field.options ?? []; track option.value) {
            <option [value]="option.value">{{ option.label }}</option>
          }
        </select>
      </div>
    }

    <!-- Rótulo, campo e lista vêm do design system. -->
    @if (field.type === 'vivest-input') {
      <vivest-input
        class="filter-bar__field filter-bar__vivest"
        autocomplete="off"
        error-message=""
        icon="search"
        status="default"
        type="text"
        [label]="field.label"
        [name]="field.key"
        [placeholder]="field.placeholder ?? ''"
        [formControlName]="field.key"
        [attr.data-testid]="'filter-' + field.key"
      ></vivest-input>
    }

    @if (field.type === 'vivest-select') {
      <vivest-select
        class="filter-bar__field filter-bar__vivest"
        status="default"
        [label]="field.label"
        [name]="field.key"
        [placeholder]="field.placeholder ?? ''"
        [options]="field.options ?? []"
        [formControlName]="field.key"
        [attr.data-testid]="'filter-' + field.key"
      ></vivest-select>
    }

    @if (field.type === 'vivest-autocomplete') {
      <vivest-autocomplete
        class="filter-bar__field filter-bar__vivest"
        error-message=""
        icon="search"
        status="default"
        [label]="field.label"
        [name]="field.key"
        [placeholder]="field.placeholder ?? ''"
        [options]="field.options ?? []"
        [formControlName]="field.key"
        [attr.data-testid]="'filter-' + field.key"
      ></vivest-autocomplete>
    }

    @if (field.type === 'date') {
      <div class="filter-bar__field">
        <label class="filter-bar__label" [for]="'filter-' + field.key">
          {{ field.label }}
        </label>
        <input
          [id]="'filter-' + field.key"
          type="date"
          class="filter-bar__control"
          [formControlName]="field.key"
          [attr.data-testid]="'filter-' + field.key"
        />
      </div>
    }

    @if (field.type === 'daterange') {
      <div class="filter-bar__field filter-bar__field--daterange">
        <span
          class="filter-bar__label"
          [id]="'filter-' + field.key + '-group-label'"
        >
          {{ field.label }}
        </span>
        <div
          class="filter-bar__daterange-row"
          role="group"
          [attr.aria-labelledby]="'filter-' + field.key + '-group-label'"
        >
          <label class="visually-hidden" [for]="'filter-' + field.key">
            Início do período
          </label>
          <input
            [id]="'filter-' + field.key"
            type="date"
            class="filter-bar__control"
            [formControlName]="field.key"
            [attr.data-testid]="'filter-' + field.key"
          />
          <span class="filter-bar__period-separator" aria-hidden="true">até</span>
          <label class="visually-hidden" [for]="'filter-' + (field.keyTo ?? '')">
            Fim do período
          </label>
          <input
            [id]="'filter-' + (field.keyTo ?? '')"
            type="date"
            class="filter-bar__control"
            [formControlName]="field.keyTo ?? ''"
            [attr.data-testid]="'filter-' + (field.keyTo ?? '')"
          />
        </div>
      </div>
    }
  }

  <div class="filter-bar__actions">
    <vivest-button variant="primary" size="md" data-testid="filter-buscar" (click)="buscar()">
      Buscar
    </vivest-button>
    <vivest-button variant="outline" size="md" data-testid="filter-limpar" (click)="limpar()">
      Limpar
    </vivest-button>
  </div>
</form>
